import React, { ReactNode } from 'react';
import styles from 'v2/common/DRM/CustomTab/index.module.scss';

interface ValueRendererProps {
  content: ReactNode;
  fieldLabel: string;
  hasValue: boolean;
}

const FieldValueRenderer = ({
  fieldLabel,
  content,
  hasValue,
}: ValueRendererProps) => {
  return (
    <>
      {hasValue ? (
        <div className={styles.descriptionTexts}>{content}</div>
      ) : (
        <label className={styles.noData}>
          Enter a {fieldLabel} for this record.
        </label>
      )}
    </>
  );
};

export default FieldValueRenderer;
